type CopyFn = (en: string, de: string, hr: string) => string;

export type PlanEditToolbarProps = {
	copy: CopyFn;
	isEditing: boolean;
	onToggleEdit: () => void;
	onDiscard?: () => void;
	onSave: () => void;
	isSaving?: boolean;
	canSave?: boolean;
	className?: string;
};

export default function PlanEditToolbar({
	copy,
	isEditing,
	onToggleEdit,
	onDiscard,
	onSave,
	isSaving = false,
	canSave = true,
	className = ''
}: PlanEditToolbarProps) {
	return (
		<div className={`d-flex flex-wrap align-items-center justify-content-end gap-2 ${className}`}>
			{isEditing && (
				<button
					type="button"
					className="btn btn-outline-danger btn-sm"
					disabled={isSaving}
					onClick={() => (onDiscard ? onDiscard() : onToggleEdit())}
				>
					<i className="bi bi-x-circle me-1" aria-hidden />
					{copy('Discard changes', 'Änderungen verwerfen', 'Odbaci promjene')}
				</button>
			)}
			{isEditing && (
				<button
					type="button"
					className="btn btn-outline-success btn-sm"
					disabled={isSaving || !canSave}
					onClick={() => void onSave()}
				>
					{isSaving ? (
						<>
							<span className="spinner-border spinner-border-sm me-1" aria-hidden />
							{copy('Saving…', 'Speichern…', 'Spremanje…')}
						</>
					) : (
						<>
							<i className="bi bi-save me-1" aria-hidden />
							{copy('Save changes', 'Änderungen speichern', 'Spremi promjene')}
						</>
					)}
				</button>
			)}
			{!isEditing && (
				<button
					type="button"
					className="btn btn-success btn-sm d-inline-flex align-items-center gap-2"
					onClick={onToggleEdit}
					disabled={isSaving}
				>
					<>
						<i className="bi bi-pencil-square" aria-hidden />
						<span>{copy('Edit plan', 'Plan bearbeiten', 'Uredi plan')}</span>
					</>
				</button>
			)}
		</div>
	);
}
